import React from "react";
import {FaTh} from "react-icons/fa";

function Explorer() {

    return (
        <div className="Exlporer">
            <h1><span className="align-text-top"><FaTh/></span> Explorer</h1>
            <div class="alert alert-warning mt-3">
                <h4>This page is under construction!</h4>
                <p>This will show some sounds in different categories.</p>
            </div>
        </div>
    );
}

export default Explorer;